import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import axios from "axios";
import urldata from "../../../../urldata";
import Imageurldata from "../../../../Imageurldata";

import Button from "../../../../component/Button/Button";
import { Col, Row, Modal } from "react-bootstrap";
import InputText from "../../../../component/InputText/InputText";

import upload from "../../../../images/careers/upload.svg";
import Toast from "../../../../component/Toast/Toast";
import close from "../../../../images/close.svg";
import check from "../../../../images/check.svg";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import config from "../../../../config/config";

const expinyearsOptions = [
  {
    name: "",
  },
  {
    name: "Months",
  },
  {
    name: "Years",
  },
];

const ContactusForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [show, setShow] = useState(false);
  const [exptabshow, setExptabshow] = useState(false);
  const [addressLine1, setaddressLine1] = useState("");
  const [addressLine2, setaddressLine2] = useState("");
  const [number, setnumber] = useState("");
  const [email, setemail] = useState("");
  const [googleMapUrl, setgoogleMapUrl] = useState("");
  const [textline1err, settextline1err] = useState("");
  const [addressNumber, setaddressNumber] = useState("");
  const [title, settitle] = useState("");
  const [link, setlink] = useState("");
  const [linkerr, setlinkErr] = useState("");
  const [headOffice, setheadOffice] = useState("");
  const [bannerimg, setbannerimg] = useState("");
  const [bannerimgerr, setbannerimgErr] = useState("");
  const [bannerimgnotpresent, setbannerimgnotpresent] = useState("");

  const [mbbannerimg, setmbbannerimg] = useState("");
  const [mbbannerimgerr, setmbbannerimgErr] = useState("");
  const [mbImgNotPresent, setmbImgNotPresent] = useState("");

  const [updateModel, setUpdateModel] = useState(false);
  const [showMobImg, setShowMobImg] = useState("");
  const [showDesktopImg, setShowDesktopImg] = useState("");
  const base_url = config.api_url;
  const [bannerid, setbannerid] = useState("");

  const [toastlist, setToastList] = useState([]);

  let toastProperties = null;

  const showToast = (type) => {
    const id = Math.floor(Math.random() * 101 + 1);
    switch (type) {
      case "success":
        toastProperties = {
          id,
          title: "Success",
          description: `Banner ${
            updateModel ? "updated" : "added"
          } Successfully`,
          backgroundColor: "#329F33",
          icon: check,
        };
        break;
      case "danger":
        toastProperties = {
          id,
          title: "Something Went Wrong",
          description: "",
          backgroundColor: "red",
          icon: close,
        };
        break;
      case "delete":
        toastProperties = {
          id,
          title: "Success",
          description: "Banner deleted Successfully",
          backgroundColor: "#329F33",
          icon: check,
        };
        break;

      default:
        setToastList([]);
    }

    setToastList([...toastlist, toastProperties]);
  };

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setUpdateModel(false);
    setShow(true);
    setShowMobImg(false);
    setShowDesktopImg(false);
    setaddressLine1("");
    setaddressLine2("");
    setemail("");
    setnumber("");
    setgoogleMapUrl("");
    //settextline1("");
    settitle("");
    setheadOffice("");
    setaddressNumber("");
    setlink("");
    setbannerimg("");
    setmbbannerimg("");
  };

  useEffect(() => {
    setLoading(true);
    //  https://api.laxmihos.com/api/contactus/form
    let url = new URL(urldata + "admin/getBannerImages");
    axios({
      method: "get",
      url: `${base_url}contactus/form`,
      //withCredentials: true,
    })
      .then((response) => {
        console.log(response);
        const templist = response.data.reverse();
        templist.forEach((item) => {
          item.createdAt =
            item.createdAt.substring(0, 10) +
            ", " +
            item.createdAt.substring(11, 19);
        });
        console.log(templist);
        setList(templist);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        //showToast("danger");
      });
  }, []);

  const handleShowForUpdate = (rowData) => {
    console.log(rowData);
    setUpdateModel(true);
    setShow(true);
    //settextline1(rowData.text)

    setlink(rowData.buttonLink);
    setaddressLine1(rowData.addressLine1);
    setaddressLine2(rowData.addressLine2);
    setemail(rowData.email);
    setnumber(rowData.number);
    setgoogleMapUrl(rowData.googleMapUrl);
    settitle(rowData.title);
    setheadOffice(rowData.headOffice);
    setaddressNumber(rowData.addressNumber);
    setbannerid(rowData._id);

    setShowMobImg(false);
    setShowDesktopImg(false);
  };

  const updateBanner = () => {
    var formData = new FormData();
    formData.append("addressLine1", addressLine1);
    formData.append("addressLine2", addressLine2);
    formData.append("email", email);
    formData.append("number", number);
    formData.append("googleMapUrl", googleMapUrl);
    formData.append("title", title);
    formData.append("headOffice", headOffice);
    formData.append("addressNumber", addressNumber);

    formData.append("screen", "home");

    if (mbImgNotPresent) {
      formData.append("mobileImageUrl", mbbannerimg);
      setmbImgNotPresent(false);
    }

    if (bannerimgnotpresent) {
      formData.append("desktopImageUrl", bannerimg);
      setbannerimgnotpresent(false);
    }

    let url = new URL(urldata + "admin/updateBannerImages");
    formData.append("id", bannerid);
    //url.searchParams.append('id', bannerid)
    var decoded = decodeURIComponent(url);

    axios({
      method: "post",
      url: "https://api.laxmihos.com/api/contactus/details/update",
      data: formData,
      //withCredentials: true,/banner/udpate
    })
      .then((response) => {
        const templist = response.data.reverse();
        setList(templist);
        showToast("success");
        setShow(false);
      })
      .catch((error) => {
        console.log("error--", error);
        setShow(false);
        // showToast("danger");
      });
  };

  const createbanner = () => {
    var formData = new FormData();
    formData.append("text", addressLine1);
    formData.append("title", title);
    formData.append("headOffice", headOffice);
    formData.append("addressNumber", addressNumber);
    formData.append("addressLine1", addressLine1);
    formData.append("addressLine2", addressLine2);
    formData.append("email", email);
    formData.append("number", number);
    formData.append("googleMapUrl", googleMapUrl);

    let url = new URL(urldata + "admin/addBannerImages");

    axios({
      method: "post",
      url: "https://api.laxmihos.com/api/contactus/details/new",
      data: formData,
      // withCredentials: true,
    })
      .then((response) => {
        // settextline1("");
        // settextline2("");
        // settextline3("");
        // setlink("");
        // setbannerimg("");
        // setmbbannerimg("");
        console.log(response);
        const templist = response.data.reverse();

        setList(templist);
        showToast("success");
        setShow(false);
      })
      .catch((error) => {
        // showToast("danger");
      });
  };

  const submit = () => {
    var formIsValid = true;

    // <<<<<<< HEAD
    // if (bannerimg) {
    //   if (bannerimg.size / 1024 > 300) {
    //     formIsValid = false
    //     setbannerimgErr("*File should be less than 300Kb.");
    //   }
    // }
    // if (mbbannerimg) {
    //   if (mbbannerimg.size / 1024 > 300) {
    //     formIsValid = false
    //     setmbbannerimg("*File should be less than 300Kb.");
    //   }
    // }

    // =======
    // >>>>>>> vijay
    if (formIsValid) {
      if (updateModel) {
        updateBanner();
      } else {
        createbanner();
      }
    }
  };

  const deleteBtnClick = (id) => {
    setLoading(true);
    let data = {};
    data.id = id;

    let url = new URL(urldata + "admin/deleteBannerImage");

    axios({
      method: "post",
      url: "https://api.laxmihos.com/api/contactus/details/delete",
      data: data,
      // withCredentials: true,
    })
      .then((response) => {
        //   showToast("success");
        //   props.onHide(); props.history.push('/admin/login')

        const templist = response.data.reverse();
        setList(templist);
        setLoading(false);
        showToast("delete");
      })
      .catch((error) => {
        // showToast("danger");
        setLoading(false);
      });
  };

  if (loading) {
    return (
      <div id="wrapper">
        <div className="profile-main-loader">
          <div className="loader">
            <svg className="circular-loader" viewBox="25 25 50 50">
              <circle
                className="loader-path"
                cx="50"
                cy="50"
                r="20"
                fill="none"
                stroke="#ed1c24"
                stroke-width="2"
              />
            </svg>
          </div>
        </div>
      </div>
    );
  }
  return (
    <>
      <MaterialTable
        title="Contact us form"
        columns={[
          { title: "Date", field: "createdAt" },
          { title: "Name", field: "name" },

          { title: "Email", field: "email" },
          { title: "Message", field: "message" },
        ]}
        data={list}
        options={{
          exportButton: true,
          actionsColumnIndex: -1,
        }}
      />

      <Modal
        {...props}
        //   size="lg"
        //   aria-labelledby="contained-modal-title-vcenter"
        dialogClassName="addbannerModel"
        centered
        show={show}
        onHide={handleClose}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="model">
          <div className="title">Add detail</div>

          <Row>
            <Col lg={3} className="column">
              <div className="titleitem">Add Title </div>
            </Col>
            <Col lg={9} className="column">
              <input
                value={title}
                onChange={(e) => settitle(e.target.value)}
                // maxlength="31"
                type="text"
              />

              {/* <div className="count">{textline1.length}/31</div> */}
            </Col>
            <Col lg={3} className="column">
              <div className="titleitem">Add Head Office </div>
            </Col>
            <Col lg={9} className="column">
              <input
                value={headOffice}
                onChange={(e) => setheadOffice(e.target.value)}
                // maxlength="31"
                type="text"
              />

              {/* <div className="count">{textline1.length}/31</div> */}
            </Col>
            <Col lg={3} className="column">
              <div className="titleitem">Add Address Line 1 </div>
            </Col>
            <Col lg={9} className="column">
              <input
                value={addressLine1}
                onChange={(e) => setaddressLine1(e.target.value)}
                // maxlength="31"
                type="text"
              />

              {/* <div className="count">{textline1.length}/31</div> */}
            </Col>
            <Col lg={3} className="column">
              <div className="titleitem">Add Address Line 2 </div>
            </Col>
            <Col lg={9} className="column">
              <input
                value={addressLine2}
                onChange={(e) => setaddressLine2(e.target.value)}
                // maxlength="31"
                type="text"
              />

              {/* <div className="count">{textline1.length}/31</div> */}
            </Col>
            <Col lg={3} className="column">
              <div className="titleitem">Add Address Number </div>
            </Col>
            <Col lg={9} className="column">
              <input
                value={addressNumber}
                onChange={(e) => setaddressNumber(e.target.value)}
                // maxlength="31"
                type="text"
              />

              {/* <div className="count">{textline1.length}/31</div> */}
            </Col>
            <Col lg={3} className="column">
              <div className="titleitem">Add Email </div>
            </Col>
            <Col lg={9} className="column">
              <input
                value={email}
                onChange={(e) => setemail(e.target.value)}
                // maxlength="31"
                type="text"
              />

              {/* <div className="count">{textline1.length}/31</div> */}
            </Col>
            <Col lg={3} className="column">
              <div className="titleitem">Add number </div>
            </Col>
            <Col lg={9} className="column">
              <input
                value={number}
                onChange={(e) => setnumber(e.target.value)}
                // maxlength="31"
                type="text"
              />

              {/* <div className="count">{textline1.length}/31</div> */}
            </Col>
            <Col lg={3} className="column">
              <div className="titleitem">Add google map url </div>
            </Col>
            <Col lg={9} className="column">
              <input
                value={googleMapUrl}
                onChange={(e) => setgoogleMapUrl(e.target.value)}
                // maxlength="31"
                type="text"
              />

              {/* <div className="count">{textline1.length}/31</div> */}
            </Col>
          </Row>
          <div className="btnContainer mt-4">
            <Button onClick={submit} title="SUBMIT" />
          </div>
        </Modal.Body>
      </Modal>
      <Toast toastList={toastlist} position="top-right" />
    </>
  );
};

export default ContactusForm;

// updateBannerImages
